import React, { useState } from 'react';
import { HeaderSort, HEADER_SORT_TYPES } from '@etiquette-ui/dynamic-table-components';
import { getCategoriesFromItem, getCategoryName } from 'pages/MenuItems/utils/transformers';

const SortCategory = ({ applyFilter, filters, globalState, text }) => {
  const translate = globalState.config.translate;
  const selectedLang = globalState.config.selectedLang;
  const categories = globalState.config.categories;

  const [type, setType] = useState(HEADER_SORT_TYPES.UNORDER);

  const onClick = () => {
    let localType = Array.from(filters.keys()).includes('category') ? type : HEADER_SORT_TYPES.UNORDER;
    switch(localType){
      case HEADER_SORT_TYPES.DESC:
        localType = HEADER_SORT_TYPES.ASC;
        break;
      case HEADER_SORT_TYPES.ASC:
        localType = HEADER_SORT_TYPES.UNORDER;
        break;
      case HEADER_SORT_TYPES.UNORDER: 
        localType = HEADER_SORT_TYPES.DESC;
    }

    setType(localType);

    applyFilter('category', (items) => {
      return items.sort((a, b) => {
        if(localType === HEADER_SORT_TYPES.UNORDER) return 0;

        const catsA = getCategoriesFromItem(categories, a);
        const A = getCategoryName(catsA, translate, selectedLang).toUpperCase();

        const catsB = getCategoriesFromItem(categories, b);
        const B = getCategoryName(catsB, translate, selectedLang).toUpperCase();
        
        if (A < B) {
          return localType===HEADER_SORT_TYPES.ASC ? 1 : -1;
        }
        if (A > B) {
          return localType===HEADER_SORT_TYPES.ASC ? -1 : 1;
        }
      });
    }, {reset: true});
  };

  return <HeaderSort 
    text={text} 
    sortType={type}
    onClick={onClick} 
    style={{ marginLeft: '16px' }}
    enabled={!Array.from(filters.keys()).includes('category')} 
  />;
};

export default SortCategory;
